import {dateUtils, logging} from "@/utils/utils";
import goalApis from "@/views/GoalSettings/api";
import contractApis from "@/views/ContractManagement/api"

export default function salesRecordsApis($apiInstance, $store) {
    const contractApi = contractApis($apiInstance, $store)
    return {
        getDistinctDeptName: async (params, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.post(`/companies/distinct/deptName`, params);

                const deptNames = response.data
                    .filter(item => item.includes("지점") || item.includes("영업소") || item === "종합병원팀")
                    .map(item => ({label: item, value: item}));

                deptNames.unshift({label: '전체', value: ''});

                success(deptNames);
            } catch (error) {
                console.log(error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        getSalesRecords: async (params, success, fail) => {
            // const {startDate, endDate} = params
            $store.commit('setIsLoading', true);

            return $apiInstance.post('/salesrecords', params)
                .then((response) => {
                    logging().exceptProd('erp salesrecords==>', response.data)
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        erpDashboard: async (params, success, fail) => {
            const {startDate, endDate} = params
            $store.commit('setIsLoading', true);

            let url = '/salesrecords/goals/erp/dashboard';
            if (startDate && endDate) {
                url += `?startDate=${startDate}&endDate=${endDate}`;
            }

            return $apiInstance.get(url)
                .then((response) => {
                    logging().exceptProd('erp goals dashboard==>', response.data)
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        ...contractApi
    }
}